export const STEP_STATUS = {
  TO_DO: 'TO_DO',
  COMPLETED: 'COMPLETED',
  NOT_VERIFIED: 'NOT_VERIFIED',
  IN_REVIEW: 'IN_REVIEW',
}
